import i18n from '@/locales';
import { createApp } from 'vue';
import RegionPurchaseBrowsing from '@/components/RegionPurchaseBrowsing.vue';

// Créer l'app Vue de base à partir de son constructeur
const app = createApp({});

// Ajouter les plugins/extensions globales à l'application
app.use(i18n);

// Ajouter le ou les composants qui devront être reconnus par l'application; <hello-world></hello-world>
app.component('RegionPurchaseBrowsing', RegionPurchaseBrowsing);

// Monter l'application sur un élément qui lui sera dédié dans le gabarit Razor; <div id="helloWorldApp"></div>
app.mount('#regionPurchaseBrowsingApp');
